module.exports = __webpack_public_path__ + "DINNextLTPro-Condensed.woff2?8a25e955d5937921981ae5956eab60bd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-Condensed.woff2
// module id = 1400
// module chunks = 0